/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _loadScript = __webpack_require__(1);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadScript = new _loadScript2.default();

/**
 * グローバル変数
 */
var ysSetTimeoutId = null;

/**
 * スクロール処理メイン
 */
function ysScroll() {
  /**
   * css,js 遅延ロード
   */
  loadScript.lazyLoadCss();
  loadScript.lazyLoadScripts();
}

/**
 * 初期化
 */
function ysInit() {
  /**
   * スクロール処理追加
   */
  window.addEventListener('scroll', function () {
    if (ysSetTimeoutId) {
      return false;
    }

    ysSetTimeoutId = setTimeout(function () {
      ysScroll();
      ysSetTimeoutId = null;
    }, 100);
  });

  /**
   * スクリプト読み込み
   */
  loadScript.loadScripts();
}

/**
 * イベント追加
 */
window.addEventListener('load', function () {
  ysInit();
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * script,cssの読み込み
 */
var YSLoadScript = function () {
  function YSLoadScript() {
    _classCallCheck(this, YSLoadScript);

    this._elementId = 'ys-main-script';
    this._scriptOnloadAttribute = 'data-ys-onload-script';
    this._scriptLazyAttribute = 'data-ys-lazy-script';
    this._cssLazyAttribute = 'data-ys-lazy-css';
    this._lazyScripts = null;
    this._lazyCss = null;
    this._waitLazyLoad = new Date();
  }

  /**
   * スクリプト読み込み
   */


  _createClass(YSLoadScript, [{
    key: 'getScripts',


    /**
     * script エレメント取得
     */
    value: function getScripts(attribute) {
      var elem = document.getElementById(this._elementId);
      if (elem == null) return null;

      var scripts = elem.getAttribute(attribute);
      if (scripts == null || scripts === '') return null;
      try {
        scripts = JSON.parse(scripts);
      } catch (e) {
        return false;
      }
      return scripts;
    }

    /**
     * 遅延読み込みスクリプト取得
     */

  }, {
    key: 'getLazyScripts',
    value: function getLazyScripts() {
      if (this._lazyScripts != null) {
        return this._lazyScripts;
      }
      this._lazyScripts = this.getScripts(this._scriptLazyAttribute);
      return this._lazyScripts;
    }

    /**
     * 遅延読み込みcss取得
     */

  }, {
    key: 'getLazyCss',
    value: function getLazyCss() {
      if (this._lazyCss != null) {
        return this._lazyCss;
      }
      this._lazyCss = this.getScripts(this._cssLazyAttribute);
      return this._lazyCss;
    }

    /**
     * 遅延ロード中止時間セット
     */

  }, {
    key: 'setWaitingTimeLazyLoad',
    value: function setWaitingTimeLazyLoad() {
      this._waitLazyLoad.setSeconds(this._waitLazyLoad.getSeconds() + 5);
    }

    /**
     * 読み込み中状態リセット
     */

  }, {
    key: 'resetWaitingTimeLazyLoad',
    value: function resetWaitingTimeLazyLoad() {
      this._waitLazyLoad = new Date();
    }

    /**
     * 遅延読み込み最中かどうか
     */

  }, {
    key: 'isWaitingLazyLoad',
    value: function isWaitingLazyLoad() {
      var now = new Date();
      return now < this._waitLazyLoad;
    }

    /**
     * javascript ちょっと遅れて読み込み
     */

  }, {
    key: 'loadScripts',
    value: function loadScripts() {
      var scripts = this.getScripts(this._scriptOnloadAttribute);
      if (scripts === null || scripts === false) return;
      for (var i = 0; i < scripts.length; i = i + 1 | 0) {
        YSLoadScript.loadScript(scripts[i].id, scripts[i].url, '');
      }
    }

    /**
     * javascript スクロールで読み込み
     */

  }, {
    key: 'lazyLoadScripts',
    value: function lazyLoadScripts() {

      var scripts = this.getLazyScripts();
      if (scripts === null || scripts === false) return;
      if (scripts.length > 0) {
        if (!this.isWaitingLazyLoad()) {
          this.setWaitingTimeLazyLoad();
          YSLoadScript.loadScript(scripts[0].id, scripts[0].url, '', this.resetWaitingTimeLazyLoad());
          this._lazyScripts.shift();
        }
      }
    }

    /**
     * css スクロールで読み込み
     */

  }, {
    key: 'lazyLoadCss',
    value: function lazyLoadCss() {
      var cssList = this.getLazyCss();
      if (cssList === null || cssList === false) return;
      if (cssList.length > 0) {
        if (!this.isWaitingLazyLoad()) {
          this.setWaitingTimeLazyLoad();
          YSLoadScript.loadCss(cssList[0].id, cssList[0].url, '', this.resetWaitingTimeLazyLoad());
          this._lazyCss.shift();
        }
      }
    }
  }], [{
    key: 'loadScript',
    value: function loadScript(id, src, deps) {
      var onloadfnc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var d = document;
      if (deps !== '') {
        if (!d.getElementById(deps)) {
          return;
        }
      }

      var js = void 0;
      if (!d.getElementById(id)) {
        js = d.createElement('script');
        js.id = id;
        js.src = src;
        js.async = true;
        if (onloadfnc != null) {
          js.onload = onloadfnc;
        }
        d.body.appendChild(js);
      }
    }

    /**
     * CSS読み込み
     */

  }, {
    key: 'loadCss',
    value: function loadCss(id, href) {
      var onloadfnc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var d = document;
      var style = void 0;
      if (!d.getElementById(id)) {
        style = d.createElement('link');
        style.id = id;
        style.href = href;
        style.rel = 'stylesheet';
        if (onloadfnc != null) {
          style.onload = onloadfnc;
        }
        d.getElementsByTagName('head')[0].appendChild(style);
      }
    }
  }]);

  return YSLoadScript;
}();

exports.default = YSLoadScript;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// ystandard.bundle.js